module.exports = __webpack_public_path__ + "img/xbts-logo.1ab4b818.png";